module.exports = __webpack_public_path__ + "static/09-de1c6dcc1c48f58ee43bb1976320a3d9.jpg";